import { render, staticRenderFns } from "./SelectDigiBoards.vue?vue&type=template&id=6bf85844&scoped=true"
import script from "./SelectDigiBoards.vue?vue&type=script&lang=js"
export * from "./SelectDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./SelectDigiBoards.vue?vue&type=style&index=0&id=6bf85844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf85844",
  null
  
)

export default component.exports